import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "matchedAddress", "manualAddress", "onSelect"];
import React from 'react';
import { Button, Message } from 'semantic-ui-react';
import { FORMATTED_ADDRESS_FOUND_TEXT } from './AddressMatchedDisplay.constants';
import { SUPPORT_EMAIL } from '../../../../../../constants';
import Modal from '../../../../../foundation/components/Modal';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props';
import AddressEnteredDisplay from '../AddressEnteredDisplay';
function AddressMatchedDisplay(_ref) {
  var open = _ref.open,
    matchedAddress = _ref.matchedAddress,
    manualAddress = _ref.manualAddress,
    onSelect = _ref.onSelect,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getModalProps = _useSemanticUiProps.getModalProps;
  return /*#__PURE__*/React.createElement(Modal, _extends({
    open: open
  }, getModalProps(rest)), /*#__PURE__*/React.createElement(Modal.Header, null, "We found a formatted address"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, FORMATTED_ADDRESS_FOUND_TEXT), /*#__PURE__*/React.createElement(Message, null, /*#__PURE__*/React.createElement(Message.Header, null, matchedAddress), "If you still have concerns about the address that we've determined, please don't hesitate to ", /*#__PURE__*/React.createElement("a", {
    href: "mailto:".concat(SUPPORT_EMAIL)
  }, "contact us"), "."), /*#__PURE__*/React.createElement(AddressEnteredDisplay, {
    address: manualAddress
  }))), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onSelect
  }, "Got it")));
}
export default AddressMatchedDisplay;